import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FullLayoutComponent } from './layouts/full-layout.component';
import { LoginComponent } from './modules/login/login.component';
import { SignupComponent } from './modules/signup/signup.component';
import { RegisterComponent } from './modules/register/register.component';
import { ForgotPasswordComponent } from './modules/forgot-password/forgot-password.component';
import { HospitalsComponent } from './modules/superadmin/hospitals/hospitals.component';
import { ProvidersComponent } from './providers/providers.component';
import { DoctorsComponent } from './modules/doctors/doctors.component';
import { InvitationsComponent } from './modules/invitations/invitations.component';
import { NotificationsComponent } from './modules/notifications/notifications.component';
import { AddDoctorComponent } from './modules/doctors/add-doctor/add-doctor.component';
import { DoctorProfileComponent } from './modules/doctors/doctor-profile/doctor-profile.component';
import { SchedulesComponent } from './modules/schedules/schedules.component';
import { AddScheduleComponent } from './modules/schedules/add-schedule/add-schedule.component';
import { EditScheduleComponent } from './modules/schedules/edit-schedule/edit-schedule.component';
import { ScheduleComponent } from './modules/schedules/schedule/schedule.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { SidebarComponent } from './modules/sidebar/sidebar.component';
import { HeaderComponent } from './modules/header/header.component';
import { SettingComponent } from './modules/setting/setting.component';
import { FooterComponent } from './modules/footer/footer.component';
import { AuthService } from './services/auth/auth.service';
import { StateService } from './services/state/state.service';
import { ToggleService } from './services/toggle/toggle.service';

// Layouts Pages
export const routes : Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
    }, {
        path: 'login',
        component: LoginComponent
    }, {
        path: 'signup',
        component: SignupComponent
    }, {
        path: 'register',
        component: RegisterComponent
    }, {
        path: 'forgotpassword',
        component: ForgotPasswordComponent
    }, {
        path: '',
        component: FullLayoutComponent,
        canActivate: [AuthService],
        data: {
            title: 'Home',
            data: {
                title: 'Dashboard'
            }
        },
        children: [
            {
                path: 'doctors',
                component: DoctorsComponent,
                canActivate: [AuthService]
            }, {
                path: 'add-doctor',
                component: AddDoctorComponent,
                data: {
                    title: 'Add Doctor'
                }
            }, {
                path: 'add-doctor/:id',
                component: AddDoctorComponent,
                data: {
                    title: 'Edit Doctor'
                }
            }, {
                path: 'doctor-profile/:id',
                component: DoctorProfileComponent,
                data: {
                    title: 'View Doctor'
                }
            }, {
                path: 'reports/pending-invitations',
                component: InvitationsComponent,
                data: {
                    title: 'Provider Invitations'
                }
            }, {
                path: 'schedules',
                component: SchedulesComponent,
                data: {
                    title: 'Schedules'
                }
            }, {
                path: 'add-schedule',
                component: AddScheduleComponent,
                data: {
                    title: 'Add Schedule'
                }
            }, {
                path: 'edit-schedule/:id',
                component: EditScheduleComponent,
                data: {
                    title: 'Edit Schedule'
                }
            }, {
                path: 'schedule/:id',
                component: ScheduleComponent,
                data: {
                    title: 'View Schedule'
                }
            }, {
                path: 'notifications',
                component: NotificationsComponent,
                data: {
                    title: 'Notifications'
                }
            }, {
                path: 'hospital',
                component: SettingComponent,
                data: {
                    title: 'Hospital Profile'
                }
            },
            {
                path: 'home',
                loadChildren: './modules/dashboard/dashboard.module#DashboardModule'
            }, {
                path: 'superadmin',
                children: [
                    {
                        path: 'institutions',
                        component: HospitalsComponent
                    }
                ]
            }, {
                path: 'providers',
                component: ProvidersComponent,
                canActivate: [StateService]
            }
        ]
    }
 
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [AuthService, ToggleService]
})
export class AppRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/app.routing.ts